import apolloClient from '../../utils/apollo-client';
import { getQuotePDF as query } from '../graphql/quote';

export default async function getQuotePDF(quoteId) {
  const response = await apolloClient().then((client) =>
    client.query({
      query,
      variables: { quoteId }
    })
  );
  return response.data.getQuotePdf;
}
